import { render, staticRenderFns } from "./AppDashboardRatingData.vue?vue&type=template&id=629937c8"
import script from "./AppDashboardRatingData.vue?vue&type=script&lang=js"
export * from "./AppDashboardRatingData.vue?vue&type=script&lang=js"
import style0 from "./AppDashboardRatingData.vue?vue&type=style&index=0&id=629937c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports